"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Meal = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Meal = function Meal(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 0A.75.75 0 018 .75V4c0 1.741-.834 3.38-2 3.996V15a1 1 0 11-2 0V7.996C2.835 7.381 2 5.742 2 4V.75a.75.75 0 01.648-.743L2.75 0a.75.75 0 01.75.75V4.5c0 .276.168.5.375.5.184 0 .337-.177.369-.41l.006-.09V.75a.75.75 0 111.5 0V4.5c0 .276.168.5.375.5.184 0 .337-.177.369-.41L6.5 4.5V.75A.75.75 0 017.25 0zm6.25 0a.5.5 0 01.5.5V15a1 1 0 11-2 0V9.661a1 1 0 00-.248-.658l-.505-.577A1 1 0 0111 7.767V4.65c0-.052.004-.105.012-.156.233-1.475.563-2.592.988-3.35.176-.303.355-.553.535-.751A1.2 1.2 0 0113.422 0h.078z",
    fill: "currentColor"
  }));
};

exports.Meal = Meal;
var _default = Meal;
exports.default = _default;